module.exports = __webpack_public_path__ + "static/img/codeIcon.7774c4ea.png";